import { autoFocusNext, validateRadioForm } from '../helpers';
import { RegistrationForm } from '../../forms/registration_form';
import { formValues } from '../../forms/form';

export default class View {
	constructor() {
        // stop if wrong page!
        if (!document.querySelector('.registration-container')) {
          return;
        }

        this.allForms = document.querySelectorAll('.form-container');
        this.progressBar = document.querySelectorAll('.bar');
        this.sections = document.querySelectorAll('.section');
        this.submitButttons = document.querySelectorAll('.button');
        this.generateForms();
    }


    // formats data to sync up with that the backend is expecting
    sanitizeFormData() {
      let dobDay = formValues["dob-day"];
      let dobMonth = formValues["dob-month"];
      let dobYear = formValues["dob-year"];

      if (dobDay && dobMonth && dobYear) {
        formValues["dateOfBirth"] = dobMonth + "-" + dobDay + "-" + dobYear;
      }
    }

    // progresses through each section in the progress bar 
    // i.e step 2: personal information, step 3: demographic identifies, etc
    resetSection(selector) {
        for (let i = 0; i < this.sections.length; i++) {
            if (this.sections[i].classList.contains(selector + '-section')) {
              this.sections[i].classList.add('active');
            } else {
              if (this.sections[i].classList.contains('active')) {
                this.sections[i].classList.remove('active');
                this.sections[i].classList.add('completed-section');
              }
            }
        }
    }

    // deals with logic for the progress bar when using the edit fields in the last step container
    editProgressBar(selector) {
      for (let i = 0; i < this.sections.length; i++) {
        if (this.sections[i].classList.contains(selector + "-section")) {
          this.sections[i].classList.add('active');
        } else {
          this.sections[i].classList.remove('active');
        }
      }

      for (let i = 0; i < this.progressBar.length; i++) {
        if (this.progressBar[i].classList.contains(selector + "-bar")) {
          this.progressBar[i].classList.add('active');
        } else {
          this.progressBar[i].classList.remove('active');
        }
      }
    }

    // default logic for updating the current step in the progress bar
    updateProgressBar(selector) {
        for (let i = 0; i < this.progressBar.length; i++) {
            if (selector === 'gender-container' || selector === 'connection-container' || selector === 'last-step-container') {
              this.resetSection(selector);
            }
            
            if (this.progressBar[i].classList.contains(selector + "-bar")) {
              this.progressBar[i].classList.add('active');
            } 
        }
    }

    // progresses through to the next form in the registration process
    nextForm(selector) {
        for (let i = 0; i < this.allForms.length; i++) {
            if (this.allForms[i].classList.contains(selector)) {
              this.allForms[i].classList.remove('hide');
            } else {
              this.allForms[i].classList.add('hide');
            }
        }
        this.updateProgressBar(selector);
    }

    // initializes all forms needed for registration flow
    generateForms() {
        let self = this;
        // Name Form
        let nameContainer = document.querySelector('.name-container');
        let nameForm = document.querySelector('.name-form');
        new RegistrationForm(nameForm, nameContainer, self, 'dob-container');

        // DOB Form
        let dobContainer = document.querySelector('.dob-container');
        let dobForm = document.querySelector('.dob-form');
        new RegistrationForm(dobForm, dobContainer, self, 'gender-container');

        // Helper for DOB Form autocomplete feature and date validation
        autoFocusNext(dobForm, true);

        // SelectedGender Form
        let genderContainer = document.querySelector('.gender-container');
        let genderForm = document.querySelector('.gender-form');
        new RegistrationForm(genderForm, genderContainer, self, 'ethnicity-container');

        // Helper for gender form validation 
        validateRadioForm(genderForm);

        // SelectedEthnicity Form
        let ethnicityContainer = document.querySelector('.ethnicity-container');
        let ethnicityForm = document.querySelector('.ethnicity-form');
        new RegistrationForm(ethnicityForm, ethnicityContainer, self, 'connection-container');

        // Helper for gender form validation 
        validateRadioForm(ethnicityForm);

        // Connection Form
        let connectionContainer = document.querySelector('.connection-container');
        let connectionForm = document.querySelector('.connection-form');
        new RegistrationForm(connectionForm, connectionContainer, self, 'facility-container');

        // Helper for connection form validation 
        validateRadioForm(connectionForm);

        // Facility Form
        let facilityContainer = document.querySelector('.facility-container');
        let faciliyForm = document.querySelector('.facility-form');
        new RegistrationForm(faciliyForm, facilityContainer, self, 'last-step-container');

        // Last Step Form
        let lastStepContainer = document.querySelector('.last-step-container');
        let lastStepForm = document.querySelector('.last-step-form');
        new RegistrationForm(lastStepForm, lastStepContainer, self, 'success-container');
    }
	// restore the view
	resetView() {
		if (!this.linkRequestPage) {
			return;
		}
		this.chosenRole.value = "";
		this.roleOptionsContainer.classList.add('hidden');
		this.requestAccessButton.disabled = true;
	}
}
